<template>
    <div class="spinbackground">
        <div class="spin"></div>
    </div>
</template>

<script>
export default {

}
</script>

<style>
    .spinbackground {
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;   
        background: #80808063;
        z-index: 9999999999999;     
    }

    .spin {
        display: block;
        width: 40px;
        height: 40px;
        margin: 30px auto;
        border: 3px solid transparent;
        border-radius: 50%;
        border-top-color: #ff8800;
        animation: spin 1s ease infinite;
        position: fixed;
        margin: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
    
    @keyframes spin {
        to { transform: rotateZ(360deg) }
    }
</style>